import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Row, Col, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Graph from '@components/dashboards/GraphView/Graph';
import TimeBasedTable from '@components/dashboards/GraphView/TimeBasedTable';
import TimeBasedLegend from '@components/dashboards/GraphView/TimeBasedLegend';
import { DASHBOARD_TAB_KEY, STATE_STATUS, DASHBOARD_DOUGHNUT_TYPES } from '@awp/constants';
import { Container } from 'react-bootstrap';
import Select from 'react-select';
import { selectFullScreen, toggle } from '@awp/stores/fullScreenSlice';
import {
  currentElasticMinute,
  currentElasticMinutes,
  setElasticMinute,
  fetchDashboardViews,
} from '@stores/dashboardViewPageSlice';
import { BOOTSTRAP_BREAKPOINTS, checkBreakpoint } from '@awp/helpers/UIHelper';
import { debounce } from '@awp/helpers/Utils';

const MonitoringGraphsView = ({ tabKey }) => {
  const [isMedium, setIsMedium] = useState(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.MEDIUM));
  const loading = useSelector((state) => state.dashboardViewPage.status);
  const fullScreen = useSelector(selectFullScreen);
  const allElasticMinutes = useSelector(currentElasticMinutes);
  const selectedElasticMinute = useSelector(currentElasticMinute);
  const dispatch = useDispatch();

  const toggleHeader = () => dispatch(toggle());

  const changeOnElasticMinute = (selOption) => {
    dispatch(setElasticMinute(selOption));
    dispatch(fetchDashboardViews());
  };

  useEffect(() => {
    const handleResize = debounce(() => {
      setIsMedium(checkBreakpoint(BOOTSTRAP_BREAKPOINTS.MEDIUM));
    }, 100);

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  return (
    <>
      <Container style={{ minHeight: '88px', marginBottom: '15px' }}>
        <Row>
          {!fullScreen.enabled ? (
            <Col sm={2}>
              <span style={{ fontSize: '0.7rem' }}>
                <b>{'Data Considered Late In'}</b>
              </span>
              <div style={{ width: '8rem', fontSize: '0.7rem', marginTop: '10px' }}>
                <Select
                  options={allElasticMinutes}
                  value={selectedElasticMinute}
                  onChange={changeOnElasticMinute}
                  isLoading={loading == STATE_STATUS.LOADING}
                  isDisabled={loading == STATE_STATUS.LOADING}
                />
              </div>
            </Col>
          ) : (
            <></>
          )}
          {DASHBOARD_TAB_KEY.TIMEBASED === tabKey && (
            <>
              <Col sm={!fullScreen.enabled ? 7 : 10}>
                <TimeBasedLegend isMedium={isMedium} />
              </Col>
              <Button sm={2} variant="secondary" style={{ maxHeight: '3rem' }} className="mr-2" onClick={toggleHeader}>
                {fullScreen.enabled ? 'Exit Full Screen' : 'Full Screen'}
              </Button>
            </>
          )}
        </Row>
      </Container>
      {DASHBOARD_TAB_KEY.OVERVIEW === tabKey && (
        <Container>
          <div className="graph__container">
            <Row>
              <Col lg={4} md={4}>
                <Graph
                  graphId={`visual-container-timeliness`}
                  presentation={tabKey}
                  insideText={DASHBOARD_DOUGHNUT_TYPES.TIMELINESS}
                  dashboardType={DASHBOARD_DOUGHNUT_TYPES.TIMELINESS}
                />
              </Col>
              <Col lg={4} md={4}>
                <Graph
                  graphId={`visual-container-completeness`}
                  presentation={tabKey}
                  insideText={DASHBOARD_DOUGHNUT_TYPES.COMPLETENESS}
                  dashboardType={DASHBOARD_DOUGHNUT_TYPES.COMPLETENESS}
                />
              </Col>
              <Col lg={4} md={4}>
                <Graph
                  graphId={`visual-container-quality`}
                  presentation={tabKey}
                  insideText={DASHBOARD_DOUGHNUT_TYPES.QUALITY}
                  dashboardType={DASHBOARD_DOUGHNUT_TYPES.QUALITY}
                />
              </Col>
            </Row>
          </div>
        </Container>
      )}
      {DASHBOARD_TAB_KEY.TIMEBASED === tabKey && <TimeBasedTable isMedium={isMedium} />}
    </>
  );
};

MonitoringGraphsView.propTypes = {
  tabKey: PropTypes.string,
};

export default MonitoringGraphsView;
